export default () => ({
  list: {
    listStyle: "none",
  },
});
